import React, { useState, useContext, useEffect } from "react";
import { ModalProvider } from "styled-react-modal";
import { StyledJournalModal, FadingBackground, CongratulationHeading, CongratulationText, DiamondContainer, CompletedItem, ProgressBarContainer, ProgressBarFilled, LevelProgressBar, GemImage, TotalScoreNow, ScoredNow, CoinsNeededText, CloseButton } from "./congratulatoryStyles";
import { CongratulatoryCardContext } from "src/consumer/context/CongraulatoryCardContext";
import { IconImage } from "../DailyPlay/DailyPlayStyles";
import { JournalContext } from "src/consumer/context/JournalContext";
import { ProfileContext } from "src/consumer/context/ProfileContext";
import partyPopperImage from "src/assets/party_popper.png";
import gemImage from "src/assets/gem.png";


export default function CongratulatoryCard() {

    const [opacity, setOpacity] = useState(0);
    const { congratulatoryCardData, setCongratulatoryCardData } = useContext(CongratulatoryCardContext);
    const { journalData, setJournalData } = useContext(JournalContext);
    const { profileData } = useContext(ProfileContext);
    const { showCard, data } = congratulatoryCardData;
    const [showExitButton, setShowExitButton] = useState(false);

    function toggleModal(e) {
        setOpacity(0);
        if (data?.completedItemType === "reflection" || data?.completedItemType === "journal") {
            setJournalData({ showJournal: true, callSource: "navbar", data: "", pageState: "", subscription: "" });
        }
        setCongratulatoryCardData({ showCard: false, data: {} })
    }
    function afterOpen() {
        setTimeout(() => {
            setOpacity(1);
        }, 100);
        if (data?.completed) {
            // toggleModal();
        }
    }
    function beforeClose() {
        return new Promise((resolve) => {
            setOpacity(0);
            setTimeout(resolve, 300);
        });
    }

    let level = Math.floor(profileData?.coins / 100) + 1;
    let progress = (profileData?.coins) * 100 / (level * 100);

    let forCompletingText;
    if (data?.completedItemType === "course") {
        forCompletingText = `For completing ${data?.itemData?.otherData?.category} activity`
    }
    if (data?.completedItemType === "journal") {
        forCompletingText = `For completing ${data?.itemData?.category} activity`
    }
    if (data?.completedItemType === "reflection") {
        forCompletingText = `For completing ${data?.itemData?.category} activity`
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowExitButton(true);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <ModalProvider backgroundComponent={FadingBackground}>
            <StyledJournalModal
                isOpen={showCard}
                afterOpen={afterOpen}
                beforeClose={beforeClose}
                onEscapeKeydown={toggleModal}
                opacity={opacity}
                backgroundProps={{ opacity }}
            >

                <div className="flex align-items-center gap-10">

                    <IconImage src={partyPopperImage} w={50} h={50} />

                    <CongratulationHeading>
                        Hooray!
                    </CongratulationHeading>

                    <IconImage src={partyPopperImage} w={50} h={50} />

                </div>

                <CongratulationText>
                    You earned
                </CongratulationText>

                <DiamondContainer>
                    <IconImage src={gemImage} w={48.64} h={38.31} />
                    {data?.coins}
                </DiamondContainer>

                <CongratulationText textTwo>
                    {forCompletingText}
                </CongratulationText>

                <CompletedItem
                    completedItemType={data?.completedItemType}
                    itemData={data?.itemData}
                />

                <LevelProgressBar>

                    <GemImage src={gemImage} progress={progress} />

                    <TotalScoreNow progress={progress}>
                        {profileData?.coins + data?.coins}
                    </TotalScoreNow>

                    <ScoredNow progress={progress}>
                        {`+${data?.coins}`}
                    </ScoredNow>

                    <ProgressBarContainer className="progress">
                        <ProgressBarFilled
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${progress}%` }}
                        />
                    </ProgressBarContainer>

                    <CoinsNeededText>
                        {level * 100 - profileData?.coins - data?.coins} coins more to level {level + 1}
                    </CoinsNeededText>

                </LevelProgressBar>

                <CloseButton show={showExitButton} onClick={toggleModal}>
                    Collect
                </CloseButton>


            </StyledJournalModal>
        </ModalProvider >
    )

}